module.exports = __webpack_public_path__ + "img/recharge-order.b8f265f4.png";